import { BadgeStatus } from '../badge-status';
import { TextTooltip } from '../text-tooltip';
import { Skeleton } from '../ui/skeleton';
import { UploadedImage } from '../uploaded-image';
import { LocalizedText } from '@/client/components/localized-text';
import { MarketStatus } from '@/libs/sdk/api';
import { memo } from 'react';
import { useLocation } from 'wouter';

export const MarketItemSkeleton = memo(() => {
  return (
    <div className="p-3 gap-3 flex items-center min-h-16 w-full">
      <Skeleton className="size-10 flex-shrink-0 rounded-3" />
      <div className="space-y-1 flex-1">
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-[80%] h-4" />
      </div>
    </div>
  );
});
MarketItemSkeleton.displayName = 'MarketItemSkeleton';

export const MarketsSkeleton = ({ len }: { len: number }) => {
  return Array.from({ length: len }).map((_, index) => <MarketItemSkeleton key={`MarketItemSkeleton-${index}`} />);
};

type MarketItemProps = {
  marketAddress: string;
  marketName: string;
  nameI18n?: Record<string, string>;
  marketPicUrl: string;
  marketStatus?: MarketStatus;
  marketDeadline?: string;
};
export const MarketItem = ({
  marketAddress,
  marketName,
  nameI18n,
  marketPicUrl,
  marketDeadline,
  marketStatus,
}: MarketItemProps) => {
  const [, navigate] = useLocation();
  return (
    <div
      onClick={() => navigate(`/market/${marketAddress}`)}
      className="p-3 gap-3 flex items-center hover:bg-foreground/4  rounded-3 min-h-16 cursor-pointer"
    >
      <UploadedImage
        fileKey={marketPicUrl}
        alt={marketName}
        width="40"
        height="40"
        className="size-10 flex-shrink-0 rounded-2"
      />
      <TextTooltip
        tooltip={<LocalizedText i18n={nameI18n}>{marketName}</LocalizedText>}
        className="line-clamp-2 text-start text-foreground font-400 text-sm"
      >
        <LocalizedText i18n={nameI18n}>{marketName}</LocalizedText>
      </TextTooltip>
      {marketDeadline && marketStatus != undefined && <BadgeStatus deadline={marketDeadline} status={marketStatus} />}
    </div>
  );
};
